<template>
  <v-card class="create-rbu">
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-text-field
          outlined
          dense
          :label="'Previous Item No. (For existing item only)'"
          v-model="result.previous_item_no"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && save()"
        depressed
        large
      >
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "DuplicateToPreviousDialog",
  props: {
    sectionId: String,
    itemId: String,
    title: String,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
      (value) =>
        (!!value && !!value.match(/^\d+(\.\d+)?[A-L]$/)) ||
        `Previous Item no. should not contain letters in the middle and should end with [A-L]`,
    ]);

    const result = ref({
      item_id: props.itemId,
      section_id: props.sectionId,
    });

    const save = async function () {
      const check_response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/item/check_duplicate_to_previous/",
        params: {
          ...result.value,
        },
      });

      if (
        check_response &&
        check_response.data &&
        check_response.data.success
      ) {
        if (check_response.data.in_progress) {
          const confirmDuplicate = await root.$dialog.confirm({
            text: `There is some existing RBU information in ${result.value.previous_item_no}. Are you sure you want to overwrite it?`,
            title: "Confirm Duplicate",
          });

          if (confirmDuplicate) {
            doDuplicate();
          }
        } else {
          doDuplicate();
        }
      }
    };

    const doDuplicate = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/item/duplicate_to_previous/",
        params: {
          ...result.value,
        },
      });

      if (response && response.data && response.data.success) {
        emit("submit", response.body.item.id);
      }
    };

    return {
      requiredRules,
      result,
      save,
      props,
    };
  },
};
</script>
